import { Component, OnInit,Input } from '@angular/core';
import { FormBuilder,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { Router,ActivatedRoute,Params } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../globals';
import { TopicService } from '../../service/topic.service';
import { commonService } from '../../service/common.service';

@Component({
  selector: 'app-topic-follow',
  templateUrl: './topic-follow.component.html',
  styleUrls: ['./topic-follow.component.css'],
  providers:[TopicService]
})
export class TopicFollowComponent implements OnInit {
  @Input() public options;
  topicList:any;
  topicListCount:any;
  topicurl:any;
  obj:any;
  isPostLoad=true;
  constructor(private _common:commonService,private global:Globals,private TopicService:TopicService,public router: Router,) { 
    this.obj={};

  }

  ngOnInit() {
    this.topicurl= this.global.topicImageUrl;
    this._common.profile.subscribe((data:any)=>{
      if(data!=null && Object.keys(data).length!=0){
        this.obj.userData = data;
      }else{
        this.obj.userData={};
        
      } 
   })

   this.followTopic();

  }

  followTopic(){
    this.TopicService.followTopic({'puserId':this.options.userId,'userId':(this.obj.userData.id)?this.obj.userData.id:this.obj.userData.id}).subscribe((data : any)=>{
       this.isPostLoad=false;
      if(data.error==0){
         this.topicList = data.results.rows;
         this.topicListCount=data.results.count;
      }
      else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        //this.router.navigate(['/']);
        }
      }
      
    })
  }


  topicFollow(topicDetail){
    if(Object.keys(this.obj.userData).length == 0){ 
      this._common.setLoginBox(true);   
      return false;
    } 
    let obj={topicId:topicDetail.id,userId:this.obj.userData.id};
    //console.log(obj);

    this.TopicService.saveFollower(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.mycount +=1;
      topicDetail.followerCount +=1;
      }
    },(error:HttpErrorResponse)=>{
      //this.msg="internal server error!";
  
    })

    
   }
   topicUnFollow(topicDetail){

    if(Object.keys(this.obj.userData).length == 0){ 
      this._common.setLoginBox(true);   
      return false;
    } 
    let obj={topicId:topicDetail.id,userId:this.obj.userData.id};
    this.TopicService.saveunFollower(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.mycount -=1;
      topicDetail.followerCount -=1;
      }
    },(error:HttpErrorResponse)=>{
     // this.msg="internal server error!";
  
    })
   }

  customdecode(data){   
    return encodeURI(btoa(data));
   }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/topic-follow/topic-follow.component.ts